import { OnInit, Component, EventEmitter, Output, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  placeholder!: string;
  @Output() searchTermChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() searchTerm: any;
  @Input() searchBarType!: string;
  searchOpen = false;
  @ViewChild('searchInput') searchInput!: ElementRef;

  constructor() {}

  ngOnInit() {
    this.placeholder = (this.searchBarType === 'map') ? '' : 'Search';
  }

  openSearchBar(bool: boolean) {
    this.searchOpen = bool;
    if (bool) {
      this.placeholder = 'Search';
      this.searchInput.nativeElement.focus();
    } else {
      this.placeholder = '';
    }
  }

  changeTerm() {
    this.searchTermChange.emit(this.searchTerm);
  }

  clearTerm() {
    this.searchTerm = '';
    this.searchTermChange.emit(this.searchTerm);
  }
}
